import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubSink } from 'subsink';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastController } from '@ionic/angular';
import { PlatformService } from 'src/app/services/platform/platform.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.page.html',
  styleUrls: ['./contact-us.page.scss'],
})
export class ContactUsPage implements OnInit {
  subscription = new SubSink();
  contactUsForm: FormGroup;

  showSpinner: boolean = false;
  response_message: string = '';

  private baseUrl = environment.base_url;

  isMobileDevice: boolean;
  frontend_url: string = environment.frontend_url;

  constructor(
    private fb: FormBuilder,
    private toast: ToastController,
    private http: HttpClient,
    private platform: PlatformService
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.readyContactUsForm();
  }

  readyContactUsForm() {
    this.contactUsForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/\S+/)]],
      email: ['', [Validators.required, Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]],
      subject: ['', [Validators.required, Validators.pattern(/\S+/)]],
      message: ['', [Validators.required, Validators.pattern(/\S+/)]]
    });
  }

  get name() {
    return this.contactUsForm.get('name');
  }
  get email() {
    return this.contactUsForm.get('email');
  }
  get subject() {
    return this.contactUsForm.get('subject');
  }
  get message() {
    return this.contactUsForm.get('message');
  }

  submitContactUsForm() {
    this.showSpinner = true;
    // console.log(this.contactUsForm.value);
    let formInfo = this.contactUsForm.value;
    this.subscription.sink = this.http.post(`${this.baseUrl}contact-us/send`, formInfo)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            this.contactUsForm.reset();
            // console.log('response ----------> ', res);
            // this.response_message = res.message;
            this.response_message = "Message request sent succesfully.";
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            this.contactUsForm.reset();
            // console.log('Error -------> ', err);
            this.response_message = "An error occurred sending your message request, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }

  privacyPolicyInBrowserOpen(){
    if (this.isMobileDevice) {
      window.open(this.frontend_url+'/privacy-policy', '_system', 'location=yes');    //New Window
    } else {
      window.open(this.frontend_url+'/privacy-policy', '_blank');   //New Tab
    }
  }

  termsConditionsInBrowserOpen(){
    if (this.isMobileDevice) {
      window.open(this.frontend_url+'/terms-conditions', '_system', 'location=yes');    //New Window
    } else {
      window.open(this.frontend_url+'/terms-conditions', '_blank');   //New Tab
    }
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

}
